var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-form-select',{class:_vm.reactiveClass,attrs:{"size":"sm","options":_vm.typeOptions},on:{"change":_vm.save},model:{value:(_vm.selectedValue),callback:function ($$v) {_vm.selectedValue=$$v},expression:"selectedValue"}})
}
var staticRenderFns = []

export { render, staticRenderFns }